class Calendar {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){

    $('.js-modal-trigger').click(function() {
      $('.js-modal').css({'opacity': '1', 'pointer-events': 'inherit'});
      $('.js-modal-date').text($(this).data('date'));
      $('.js-modal-txt').text($(this).data('txt'));
    })

    $('[data-class="js-modal-close"]').click(function() {
      $('.js-modal').css({'opacity': '0', 'pointer-events': 'none'});
    })

    let date = new Date();
    let swiper = new Swiper(".calendarSwiper", {
      initialSlide: $(`[data-year="${date.getFullYear()}"][data-month="${date.getMonth() + 1}"]`).index(),
      allowTouchMove: false,
      speed: 600,
      spaceBetween: 40,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });
  }
}